import type { MensagensIzza } from "../../../services/enviosIzza"

export enum VerEnviosIzzaActionsTypes {
    CARREGAR = "CARREGAR",
}

export type VerEnviosIzzaActions = {
    type: VerEnviosIzzaActionsTypes.CARREGAR
    payload: MensagensIzza
}
